import { createAsyncThunk } from '@reduxjs/toolkit';
import { getToken } from '../../Utils/authUtils';
import { REPORTS } from '../../constant';

interface Payload {
  studyInstanceUIDs: string[];
  hospitalId: string;
}

export const getPatientNameOverridesApi = createAsyncThunk(
  'getPatientNameOverrides',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const res = await fetch(REPORTS.GET_PATIENT_NAME_OVERRIDES, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.msg || 'Failed to fetch patient name overrides');
      }
      return await res.json();
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);
